// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { API_PATH } from '../Constant/constants';
// import useAuth from '../config/useAuth';
// import DoctorScheduleModal from './DoctorScheduleModal'; // Adjust path if needed

// const DoctorBookingListPage = () => {
//   const { user, token } = useAuth();
//   const [scheduleList, setScheduleList] = useState([]);
//   const [selectedSchedule, setSelectedSchedule] = useState(null);
//   const [newSlot, setNewSlot] = useState({ startTime: '', endTime: '', status: 'AVAILABLE' });
//   const [showSlotPopup, setShowSlotPopup] = useState(false);
//   const [showSchedulePopup, setShowSchedulePopup] = useState(false);

//   useEffect(() => {
//     fetchBookingData();
//   }, [user.id, token]);

//   const fetchBookingData = async () => {
//     try {
//       const response = await axios.get(`${API_PATH}/doctors/${user.id}/schedule/list`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setScheduleList(response.data);
//     } catch (error) {
//       console.error('Error fetching booking list:', error);
//     }
//   };

//   const openSlotPopup = (scheduleId) => {
//     setSelectedSchedule(scheduleId);
//     setShowSlotPopup(true);
//   };

//   const handleAddSlot = async () => {
//     try {
//       const targetScheduleId = selectedSchedule || prompt("Enter Schedule ID to add slot:");
//       if (!targetScheduleId) {
//         alert("Schedule ID is required");
//         return;
//       }

//       await axios.post(`${API_PATH}/doctors/schedule/${targetScheduleId}/slot`, newSlot, {
//         headers: { Authorization: `Bearer ${token}` },
//       });

//       setShowSlotPopup(false);
//       setNewSlot({ startTime: '', endTime: '', status: 'AVAILABLE' });
//       alert('Slot added successfully');
//       fetchBookingData(); // Refresh
//     } catch (error) {
//       console.error('Error adding slot:', error);
//       alert('Failed to add slot');
//     }
//   };

//   return (
//     <div className="container py-4 bg-white shadow rounded my-4 w-100 mw-100">
//       <h4>className="mb-4">Doctor Booking List</h4>

//       {/* Action Buttons */}
//       <div className="d-flex justify-content-end mb-3 gap-2">
//         <button
//           className="btn btn-success"
//           onClick={() => {
//             setSelectedSchedule(null);
//             setShowSlotPopup(true);
//           }}
//         >
//           + Add Slot
//         </button>
//         <button className="btn btn-info" onClick={() => setShowSchedulePopup(true)}>
//           + Create Schedule
//         </button>
//       </div>

//       {scheduleList.length === 0 ? (
//         <p>No booking records found.</p>
//       ) : (
//         <div className="table-responsive">
//           <table className="table table-bordered">
//             <thead className="table-dark text-white">
//               <tr>
//                 <th>#</th>
//                 <th>Schedule Date</th>
//                 <th>Start Time</th>
//                 <th>End Time</th>
//                 <th>Appointment Slots</th>
//                 <th>Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {scheduleList.map((schedule, index) => (
//                 <tr key={index}>
//                   <td>{index + 1}</td>
//                   <td>{schedule.scheduleDate}</td>
//                   <td>{schedule.startTime}</td>
//                   <td>{schedule.endTime}</td>
//                   <td>
//                     <ul className="list-unstyled mb-0">
//                       {schedule.appointmentSlots?.length ? (
//                         schedule.appointmentSlots.map((slot, i) => (
//                           <li key={i}>{slot.startTime} - {slot.endTime} | Status: {slot.status}</li>
//                         ))
//                       ) : (
//                         <li>No Slots</li>
//                       )}
//                     </ul>
//                   </td>
//                   <td>
//                     <button className="btn btn-primary btn-sm" onClick={() => openSlotPopup(schedule.id)}>Add Slot</button>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       )}

//       {/* Add Slot Modal */}
//       {showSlotPopup && (
//         <div className="modal show d-block" tabIndex="-1" role="dialog">
//           <div className="modal-dialog" role="document">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title">Add Slot</h5>
//                 <button type="button" className="btn-close" onClick={() => setShowSlotPopup(false)}></button>
//               </div>
//               <div className="modal-body">
//                 <label>Start Time:</label>
//                 <input
//                   type="time"
//                   className="form-control mb-2"
//                   value={newSlot.startTime}
//                   onChange={(e) => setNewSlot({ ...newSlot, startTime: e.target.value })}
//                 />
//                 <label>End Time:</label>
//                 <input
//                   type="time"
//                   className="form-control mb-2"
//                   value={newSlot.endTime}
//                   onChange={(e) => setNewSlot({ ...newSlot, endTime: e.target.value })}
//                 />
//               </div>
//               <div className="modal-footer">
//                 <button className="btn btn-secondary" onClick={() => setShowSlotPopup(false)}>Cancel</button>
//                 <button className="btn btn-primary" onClick={handleAddSlot}>Add Slot</button>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Create Schedule Modal */}
//       {showSchedulePopup && (
//         <DoctorScheduleModal onClose={() => setShowSchedulePopup(false)} />
//       )}
//     </div>
//   );
// };

// export default DoctorBookingListPage;

import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_PATH } from '../Constant/constants';
import useAuth from '../config/useAuth';
import DoctorScheduleModal from './DoctorScheduleModal';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const DoctorBookingListPage = () => {
  const { user, token } = useAuth();
  const [scheduleList, setScheduleList] = useState([]);
  const [selectedSchedule, setSelectedSchedule] = useState(null);
  const [newSlot, setNewSlot] = useState({ startTime: '', endTime: '', status: 'AVAILABLE' });
  const [showSlotPopup, setShowSlotPopup] = useState(false);
  const [showSchedulePopup, setShowSchedulePopup] = useState(false);
  const [statusFilter, setStatusFilter] = useState('');
  const [dateFilter, setDateFilter] = useState(null);
  const [loading, setLoading] = useState(true);


  const [editSchedule, setEditSchedule] = useState(null);
  const [editFormData, setEditFormData] = useState({
    id: 0,
    doctorId: user?.id || 0,
    scheduleDate: '',
    startTime: '',
    endTime: '',
    slotInterval: 15,
    unavailableSlots: [],
    appointmentSlots: [],
  });


  const [editSlotData, setEditSlotData] = useState(null);






  // const handleDeleteSchedule = async (id) => {
  //   try {
  //     await axios.delete(`${API_PATH}/doctors/schedule/${id}`, {
  //       headers: { Authorization: `Bearer ${token}` }
  //     });
  //     toast.success("Schedule deleted successfully");
  //     fetchBookingData();
  //   } catch (error) {
  //     console.error("Schedule deletion error:", error);

  //     if (error.response && error.response.status === 500) {
  //       toast.error("Cannot delete schedule. It may have booked slots or server error.");
  //     } else {
  //       toast.error("Failed to delete schedule. Please try again.");
  //     }
  //   }
  // };


  const handleDeleteSchedule = async (id, slotCount) => {
    if (slotCount > 0) {
      toast.error(" Cannot delete schedule: Please delete all slots first.");
      return;
    }

    try {
      await axios.delete(`${API_PATH}/doctors/schedule/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success("Schedule deleted successfully.");
      fetchBookingData();
    } catch (error) {
      console.error("Schedule deletion error:", error);

      // Check if server responded with a detailed error
      if (
        error.response &&
        typeof error.response.data === "string" &&
        error.response.data.includes("violates foreign key constraint")
      ) {
        toast.error("❌ Cannot delete schedule: It has linked appointment slots.");
      } else {
        toast.error("❌ An error occurred while deleting the schedule.");
      }
    }
  };




  const confirmAndDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this schedule?")) {
      handleDeleteSchedule(id);
    }
  };




  const handleEditSchedule = (schedule) => {
    setEditFormData({
      id: schedule.id,
      doctorId: user?.id,
      scheduleDate: schedule.scheduleDate,
      startTime: schedule.startTime,
      endTime: schedule.endTime,
      slotInterval: schedule.slotInterval || 15,
      unavailableSlots: schedule.unavailableSlots || [],
      appointmentSlots: schedule.appointmentSlots || [],
    });
    setEditSchedule(schedule.id);
  };


  const submitEditSchedule = async () => {
    try {
      await axios.patch(`${API_PATH}/doctors/schedule/${editFormData.id}`, editFormData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success("Schedule updated successfully");
      setEditSchedule(null);
      fetchBookingData();
    } catch (error) {
      toast.error("Error updating schedule");
    }
  };





  useEffect(() => {
    fetchBookingData();
  }, [user.id, token]);

  const fetchBookingData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${API_PATH}/doctors/${user.id}/schedule/list`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setScheduleList(response.data);
    } catch (error) {
      toast.error('Error fetching booking list');
    } finally {
      setLoading(false);
    }
  };

  const openSlotPopup = (scheduleId) => {
    setSelectedSchedule(scheduleId);
    setShowSlotPopup(true);
  };

  // const handleAddSlot = async () => {
  //   try {
  //     await axios.post(`${API_PATH}/doctors/schedule/${selectedSchedule}/slot`, newSlot, {
  //       headers: { Authorization: `Bearer ${token}` },
  //     });
  //     setShowSlotPopup(false);
  //     setNewSlot({ startTime: '', endTime: '', status: 'AVAILABLE' });
  //     toast.success('Slot added successfully');
  //     fetchBookingData();
  //   } catch (error) {
  //     toast.error('Failed to add slot');
  //   }
  // };

  const handleDeleteSlot = async (slotId) => {
    try {
      await axios.delete(`${API_PATH}/appointment-slot/${slotId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Slot deleted');
      fetchBookingData();
    } catch (error) {
      toast.error('Error deleting slot');
    }
  };

  const handleSlotStatusChange = (slotId, newStatus) => {
    axios.patch(`${API_PATH}/appointment-slot/${slotId}`, { status: newStatus }, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(() => {
        toast.success('Slot updated');
        fetchBookingData();
      })
      .catch(() => toast.error('Failed to update slot'));
  };

  const filteredSchedules = scheduleList.filter(sch => {
    const dateMatch = !dateFilter || sch.scheduleDate === dateFilter.toISOString().split('T')[0];
    return dateMatch;
  });


  const handleAddSlot = async () => {
    if (!newSlot.startTime || !newSlot.endTime) {
      toast.error("Please enter both start and end times.");
      return;
    }

    try {
      const selectedScheduleObj = scheduleList.find(sch => sch.id === selectedSchedule);
      if (!selectedScheduleObj) {
        toast.error("Schedule not found");
        return;
      }

      const payload = {
        doctorId: user?.id || 0,
        scheduleId: selectedSchedule,
        appointmentDate: selectedScheduleObj.scheduleDate,
        startTime: newSlot.startTime,
        endTime: newSlot.endTime,
        status: newSlot.status
      };

      await axios.post(`${API_PATH}/appointment-slot`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setShowSlotPopup(false);
      setNewSlot({ startTime: '', endTime: '', status: 'AVAILABLE' });
      toast.success('Slot added successfully');
      fetchBookingData();
    } catch (error) {
      console.error("Error adding slot:", error);
      toast.error('❌ Failed to add slot');
    }
  };




  const handleUpdateSlot = async (updatedFields) => {
    try {
      const slotPayload = {
        slotId: updatedFields.slotId,
        doctorId: user?.id,
        scheduleId: updatedFields.scheduleId,
        appointmentDate: updatedFields.appointmentDate,
        startTime: updatedFields.startTime,
        endTime: updatedFields.endTime,
        status: updatedFields.status,
      };

      await axios.patch(`${API_PATH}/appointment-slot/${updatedFields.slotId}`, slotPayload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      toast.success("Slot updated successfully");
      fetchBookingData();
    } catch (error) {
      console.error("Universal slot update error:", error);
      toast.error("❌ Failed to update slot");
    }
  };






  return (
    <div className="container py-4 bg-white shadow rounded my-4 w-100 mw-100">
      <h4 className="mb-4">Doctor Booking List</h4>
      <ToastContainer />

      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className="d-flex align-items-center gap-2">
          <DatePicker
            selected={dateFilter}
            onChange={(date) => setDateFilter(date)}
            placeholderText="Filter by Date"
            className="form-control"
          />
          <select value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)} className="form-select">
            <option value="">All Status</option>
            <option value="AVAILABLE">AVAILABLE</option>
            <option value="BOOKED">BOOKED</option>
          </select>
        </div>
        <div>
          {/* <button className="btn btn-success me-2" onClick={() => { setSelectedSchedule(null); setShowSlotPopup(true); }}>+ Add Slot</button> */}
          <button className="btn btn-info" onClick={() => setShowSchedulePopup(true)}>+ Create Schedule</button>
        </div>
      </div>

      {loading ? (
        <Skeleton count={10} height={40} />
      ) : filteredSchedules.length === 0 ? (
        <p>No booking records found.</p>
      ) : (
        <div className="table-responsive">
          <table className=" table-bordered">
            <thead className=" text-white tableborder">
              <tr>
                <th>#</th>
                <th>Schedule Date</th>
                <th>Start Time</th>
                <th>End Time</th>
                <th>Appointment Slots</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredSchedules.map((schedule, index) => (
                <tr key={index} className='datahover'>
                  <td>{index + 1}</td>
                  <td>{schedule.scheduleDate}</td>
                  <td>{schedule.startTime}</td>
                  <td>{schedule.endTime}</td>
                  <td>
                    <ul className="list-unstyled mb-0">
                      {schedule.appointmentSlots?.filter(slot => !statusFilter || slot.status === statusFilter).map((slot, i) => (
                        <li key={i} className="d-flex justify-content-between align-items-center">
                          <span>{slot.startTime} - {slot.endTime} | {slot.status}</span>
                          <div className="btn-group btn-group-sm gap-3">
                            <button
                              className="btn btn-outline-info rounded mb-2"
                              onClick={() =>
                                setEditSlotData({
                                  ...slot,
                                  scheduleId: schedule.id,
                                  doctorId: user.id,
                                  appointmentDate: schedule.scheduleDate,
                                })
                              }
                            >
                              Edit Slot
                            </button>

                            {/* <button className="btn btn-outline-danger" onClick={() => handleDeleteSlot(slot.slotId)}>&times;</button> */}
                            <button className="btn btn-outline-danger rounded mb-2" onClick={() => handleDeleteSlot(slot.slotId)}>Delete Slot</button>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </td>
                  <td>
                    {/* <button className="btn btn-primary btn-sm" onClick={() => openSlotPopup(schedule.id)}>Add Slot</button> */}

                    <td>
                      <div className="d-flex flex-row gap-1">
                        <button className="btn btn-primary fw-700 btn-sm" onClick={() => openSlotPopup(schedule.id)}>Add Slot</button>
                        <button className="btn btn-warning btn-sm" onClick={() => handleEditSchedule(schedule)}>Edit Schedule</button>

                        <button className="btn btn-danger btn-sm" onClick={() => confirmAndDelete(schedule.id)}>Delete Schedule</button>

                      </div>
                    </td>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {showSlotPopup && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Slot</h5>
                <button type="button" className="btn-close" onClick={() => setShowSlotPopup(false)}></button>
              </div>
              <div className="modal-body">
                <label>Start Time:</label>
                <input type="time" className="form-control mb-2" value={newSlot.startTime} onChange={(e) => setNewSlot({ ...newSlot, startTime: e.target.value })} />
                <label>End Time:</label>
                <input type="time" className="form-control mb-2" value={newSlot.endTime} onChange={(e) => setNewSlot({ ...newSlot, endTime: e.target.value })} />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowSlotPopup(false)}>Cancel</button>
                <button className="btn btn-primary" onClick={handleAddSlot}>Add Slot</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {editSchedule && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Schedule</h5>
                <button type="button" className="btn-close" onClick={() => setEditSchedule(null)}></button>
              </div>
              <div className="modal-body">
                <label>Date:</label>
                <input type="date" className="form-control mb-2"
                  value={editFormData.scheduleDate}
                  onChange={(e) => setEditFormData({ ...editFormData, scheduleDate: e.target.value })}
                />
                <label>Start Time:</label>
                <input type="time" className="form-control mb-2"
                  value={editFormData.startTime}
                  onChange={(e) => setEditFormData({ ...editFormData, startTime: e.target.value })}
                />
                <label>End Time:</label>
                <input type="time" className="form-control mb-2"
                  value={editFormData.endTime}
                  onChange={(e) => setEditFormData({ ...editFormData, endTime: e.target.value })}
                />
                <label>Slot Interval (minutes):</label>
                <input type="number" className="form-control mb-2"
                  value={editFormData.slotInterval}
                  onChange={(e) => setEditFormData({ ...editFormData, slotInterval: parseInt(e.target.value) })}
                />
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setEditSchedule(null)}>Cancel</button>
                <button className="btn btn-success" onClick={submitEditSchedule}>Save Changes</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showSlotPopup && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Slot</h5>
                <button type="button" className="btn-close" onClick={() => setShowSlotPopup(false)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-2">
                  <label>Start Time:</label>
                  <input
                    type="time"
                    className="form-control"
                    value={newSlot.startTime}
                    onChange={(e) =>
                      setNewSlot({ ...newSlot, startTime: e.target.value })
                    }
                  />
                </div>
                <div className="mb-2">
                  <label>End Time:</label>
                  <input
                    type="time"
                    className="form-control"
                    value={newSlot.endTime}
                    onChange={(e) =>
                      setNewSlot({ ...newSlot, endTime: e.target.value })
                    }
                  />
                </div>
                <div className="mb-2">
                  <label>Status:</label>
                  <select
                    className="form-select"
                    value={newSlot.status}
                    onChange={(e) =>
                      setNewSlot({ ...newSlot, status: e.target.value })
                    }
                  >
                    <option value="AVAILABLE">AVAILABLE</option>
                    <option value="BOOKED">BOOKED</option>
                  </select>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowSlotPopup(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" onClick={handleAddSlot}>
                  Add Slot
                </button>
              </div>
            </div>
          </div>
        </div>
      )}


      {editSlotData && (
        <div className="modal show d-block" tabIndex="-1" role="dialog">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Slot</h5>
                <button type="button" className="btn-close" onClick={() => setEditSlotData(null)}></button>
              </div>
              <div className="modal-body">
                <label>Date:</label>
                <input
                  type="date"
                  className="form-control mb-2"
                  value={editSlotData.appointmentDate}
                  onChange={(e) =>
                    setEditSlotData({ ...editSlotData, appointmentDate: e.target.value })
                  }
                />

                <label>Start Time:</label>
                <input
                  type="time"
                  className="form-control mb-2"
                  value={editSlotData.startTime}
                  onChange={(e) =>
                    setEditSlotData({ ...editSlotData, startTime: e.target.value })
                  }
                />

                <label>End Time:</label>
                <input
                  type="time"
                  className="form-control mb-2"
                  value={editSlotData.endTime}
                  onChange={(e) =>
                    setEditSlotData({ ...editSlotData, endTime: e.target.value })
                  }
                />

                <label>Status:</label>
                <select
                  className="form-control mb-2"
                  value={editSlotData.status}
                  onChange={(e) =>
                    setEditSlotData({ ...editSlotData, status: e.target.value })
                  }
                >
                  <option value="AVAILABLE">AVAILABLE</option>
                  <option value="BOOKED">BOOKED</option>
                </select>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setEditSlotData(null)}>
                  Cancel
                </button>
                <button className="btn btn-success" onClick={() => handleUpdateSlot(editSlotData)}>
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}




      {showSchedulePopup && <DoctorScheduleModal onClose={() => setShowSchedulePopup(false)} />}
    </div>
  );
};

export default DoctorBookingListPage;
